var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"simple-header"},[_c('i',{staticClass:"nbicon nbfanhui",on:{"click":_vm.goBack}}),_c('div',{staticClass:"simple-header-name"},[_vm._v(_vm._s(_vm.name))]),_c('i',{staticClass:"nbicon nbmore"})])
}
var staticRenderFns = []

export { render, staticRenderFns }